export default __webpack_public_path__ + "static/media/main.f02d5421.png";